import React from "react";

export const Input = React.forwardRef(({ className = "", type = "text", ...props }, ref) => {
  // Base classes that can be overridden
  const baseClasses = "flex h-10 w-full rounded-md border px-3 py-2 text-sm placeholder:text-gray-500 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-amber-600 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50";
  
  // Default light theme classes (only if no dark theme classes are provided)
  const defaultClasses = className.includes('bg-gray-800') || className.includes('text-white') 
    ? "" 
    : "border-gray-300 bg-white text-gray-900";
  
  return (
    <input
      type={type}
      className={`${baseClasses} ${defaultClasses} ${className}`}
      ref={ref}
      {...props}
    />
  );
});

Input.displayName = "Input";